import { NgForm } from '@angular/forms';
import { ViewChild } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { AttachDetachStepperModel } from '../../model/attach-detach-step-model';
import { Component, OnInit } from '@angular/core';
import { TransportAttachDetachStepperService } from '../../service/transport-attach-detach-stepper.service';

@Component({
    selector: 'app-detach-trailer',
    templateUrl: './detach-trailer.component.html',
    styleUrls: ['./detach-trailer.component.scss'],
    standalone: false
})
export class DetachTrailerComponent implements OnInit {

  stepperModel: AttachDetachStepperModel;

  @ViewChild('detachTrailerForm', { static: true }) detachTrailerForm: NgForm;

  constructor(
    public translationService: TranslationService,
    private stepperService: TransportAttachDetachStepperService
  ) {
    this.stepperModel = this.stepperService.stepperModel;

    // hook to enable/disable next button
    this.stepperModel.stepCompleted = () => {
      if (!this.detachTrailerForm) {
        return false;
      }
      return this.detachTrailerForm.valid;
    };

    this.stepperModel.getNextStepIndex = () => {
      return 0;
    };

    this.stepperModel.getPreviousStepIndex = () => {
      return 0;
    };

    this.stepperModel.beforeNextStep = () => {
      return true;
    };
  }

  ngOnInit() {
  }

}
